import { Injectable } from '@angular/core';
import { SERVER_API_URL } from '../environment.constants';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ParamContext } from '../shared/service/param.context';
import { Observable } from 'rxjs';
import { createRequestOption } from '../shared';
import { GermplasmPairTraitSearchRequestModel } from './model/germplasm-pair-trait-search-request.model';
import { GermplasmPairTraitModel } from './model/germplasm-pair-trait.model';
import { TrialEnvironmentSearchRequest } from '../shared/query/model/trial-environment-search-request.model';
import { TrialEnvironmentSearchResponse } from '../shared/query/model/trial-environment-search-response.model';
import { VariableResultsRequestModel } from './model/variable-results-request.model';
import { GermplasmPairResultModel } from './model/germplasm-pair-result.model';

@Injectable()
export class HeadToHeadQueryService {
    private baseUrl = SERVER_API_URL;

    constructor(
        private http: HttpClient,
        private paramContext: ParamContext
    ) {
    }

    public getGermplasmPairTraits(requestModel: GermplasmPairTraitSearchRequestModel, req ?: any): Observable<HttpResponse<GermplasmPairTraitModel[]>> {
        const params = createRequestOption(req);
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/head-to-head/traits`;
        return this.http.post<GermplasmPairTraitModel[]>(url, requestModel, {
            params,
            observe: 'response'
        });
    }

    public getSearchResults(trialEnvironmentSearchRequest?: TrialEnvironmentSearchRequest): Observable<HttpResponse<TrialEnvironmentSearchResponse[]>> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/head-to-head/environment/search`;
        return this.http.post<TrialEnvironmentSearchResponse[]>(url, trialEnvironmentSearchRequest, { observe: 'response' });
    }

    public getGermplasmPairResults(request: VariableResultsRequestModel): Observable<HttpResponse<GermplasmPairResultModel[]>> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/head-to-head/results`;
        return this.http.post<GermplasmPairResultModel[]>(url, request, { observe: 'response' });
    }

    public exportResults(request: VariableResultsRequestModel): Observable<HttpResponse<Blob>> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/head-to-head/download-results`;
        return this.http.post(url, request, { observe: 'response', responseType: 'blob' });
    }
}